const logotext = 'LightWorkers';
const meta = {
  title: 'John Doe',
  description:
    'I’m John Doe Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.'
};

const introdata = {
  title: 'I’m John Doe',
  animated: {
    first: 'I love your school',
    second: 'I will love to apply my child',
    third: 'I will like to ask some questions',
  },
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum',
  your_img_url: 'https://images.unsplash.com/photo-1514790193030-c89d266d5a9d',
};


const services = [
  {
    title: 'A-Levels',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.',
  },
  {
    title: 'Special Tutorials',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.',
  },
  {
    title: 'College students',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.',
  },
];

const contactConfig = {
  YOUR_EMAIL: 'lightworkers.ng.01@gmail.com, lightworkers.ng.02@gmail.com',
  YOUR_FONE: '09061322455',
  description:
    'The information on this form is taken to record the applicants simplest details and also contact the prospective applicant',
  YOUR_SERVICE_ID: 'service_id',
  YOUR_TEMPLATE_ID: 'template_id',
  YOUR_USER_ID: 'user_id',
};

 
export {
  meta,
  services,
  introdata,
  contactConfig, 
  logotext,
};